module.exports = __webpack_public_path__ + "static/media/portfolio_title_6.25d6304f.svg";